// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1vSXk","insightsList":"newBusinessInsightsMenu_insightsList__XzufE","active":"newBusinessInsightsMenu_active__2yxV0"};